'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import { useTheme } from '@classify/react-core-components/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { TOC_STORAGE_KEY } from '../_constants/toc';
const TOC_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;
export default function useTocState(isTocInitiallyOpen) {
  const $ = _c(8);
  const {
    breakpoints
  } = useTheme();
  let t0;
  if ($[0] !== breakpoints) {
    t0 = breakpoints.up("sm");
    $[0] = breakpoints;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const shouldSaveToCState = useMediaQuery(t0);
  const [isTocOpen, setIsTocOpen] = useState(isTocInitiallyOpen);
  let t1;
  let t2;
  if ($[2] !== isTocOpen || $[3] !== shouldSaveToCState) {
    t1 = () => {
      if (shouldSaveToCState) {
        localStorage.setItem(TOC_STORAGE_KEY, String(isTocOpen));
      }
      document.cookie = `${TOC_STORAGE_KEY}=${String(isTocOpen)}; path=/; max-age=${TOC_COOKIE_MAX_AGE_SECONDS}; SameSite=Lax`;
    };
    t2 = [isTocOpen, shouldSaveToCState];
    $[2] = isTocOpen;
    $[3] = shouldSaveToCState;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== isTocOpen) {
    t3 = [isTocOpen, setIsTocOpen];
    $[6] = isTocOpen;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3 as const;
}